export const customer = {
  /**
   * Gets the programmatic name of the entire locale, with the language,
   *   country and variant separated by underbars. The Language is always lower case,
   *   and country is always upper case. If the language is missing,
   *   the string will begin with an underscore character.
   *   If both the language and country fields are missing,
   *   this function will return the empty string,
   *   even if the variant field is filled in (you cannot have a locale with just a variant--
   *   the variant must accompany a valid language or country code). Examples: "en"
   *
   */
  en: {
    customer_onboarding: "Customer Onboarding",
    add_customer: "Add Customer",
    customer_id: "Customer ID",
    customer_name: "Customer Name",
    customer_category: "Customer Category",
    email_id: "Email ID",
    phone: "Phone",
    location: "Location",
    action: "Action",
    select: "Select",
    utility_type: "Utility Type",
    mobile: "Mobile",
    user_name: "User Name",
    hint_billing_type: "hint: Retrofit or New Customer",
    image_format: "Only allowed jpg, jpeg, png",
    image_size: "Size Maximum 2MB",
    bulk_upload: "Bulk Upload",
    choose_file: "Choose File",
    status: "Status",
    select_customer: "Select customer",
    delete_confrim_msg:"Are you sure you want to delete this customer?",
    form: {
      hint:'Maximum 100 characters Only',
      customer_sub_name: "Customer Sub Name",
      status: "Status",
      project_types: "Project Types",
      product_category: "Product Category",
      product_name: "Product Name",
      project_name: "Project Name",
      location_category_name: "Location Category Name",
      category_name: "Category Name",
      add_customer: "Add Customer",
      edit_customer: "Edit Customer",
      personal_information: "Personal Information",
      name: "Name",
      description: "Description",
      email_id: "Primary Email ID",
      group_email_id: "Secondary Email ID",
      contact_number: "Contact Number",
      customer_logo: "Customer Logo",
      is_active: "Is active",
      is_inactive: "Is Inactive",
      address_line1: "Address Line1",
      address_line2: "Address Line2",
      country: "Country",
      select_country: "Select country",
      state: "state",
      select_state: "Select State",
      city: "city",
      select_city: "Select City",
      pincode: "pincode",
      category: "Category",
      select_category: "Select category",
      color_configration: "Color Configuration",
      alert: "Alert",
      select: "Select",
      threshold: "Threshold",
      product_types: "Product Types",
      product_categories: "Product Categories",
      normal: "Normal",
      user_configration: "User Configuration",
      username: "Username",
      password: "Password",
      confirm_password: "Confirm Password",
      cancel: "cancel",
      loading: "loading..",
      select_pincode: "Select pincode",
      submit: "Submit",
      customer_status: "Customer Status",
      business_type: "Business Type",
      billing_type: "Billing Type",
      prepaid: "Prepaid",
      postpaid: "Postpaid",
      utility_type: "Utility Type",
      select_utility: "Select Utility",
      phone_number: "Phone Number",
      mobile_number: "Mobile Number",
      plus_nine_one: "+91",
      new_customer: "New Customer",
      retrofit: "Retrofit",
      customer_name: "Customer Name",
      oem_fit: "OEM Fit",
      retro_fit: "Retro Fit",
      about_customer: "About Customer",
      select_mode: "Select Mode",
      current_mode: "Current Mode",
      batch_mode_data: "Mode 1 (Batch Mode Data)",
      instantaneous_data: "Mode 2 (Instantaneous Data)",
      slAppCredentials: "SmartLight Application Credentials",
      oldLampWattageLabel:"Old Lamp Wattage",
      ledWattageLabel:"New Lamp Wattage",
      ledModelNumberLabel:"Led Model Number",
      minPowerConsumptionLable:"Min Power Consumption",
      maxPowerConsumptionLable:"Max Power Consumption",
      lampBrand:"Lamp Brand Name",
      lamp:"Lamp",
      modelNumbers:"Model Numbers",
      captcha:"Captcha"
    }
  },

  ar: {
    customer_onboarding: "إعداد العملاء",
    add_customer: "أضف الزبون",
    customer_id: "هوية الزبون",
    customer_name: "اسم الزبون",
    customer_category: "فئة العميل",
    email_id: "عنوان الايميل",
    phone: "الهاتف",
    location: "الموقع",
    action: "العمل",
    select: "اختيار",
    utility_type: "نوع المنفعة",
    mobile: "الهاتف المحمول",
    user_name: "اسم االمستخدم",
    hint_billing_type: "تلميح: تعديل التحديث أو زبون جديد",
    image_format: "مسموح فقط بتنسيق jpg jpeg png",
    image_size: "الحجم الأقصى 2 ميغا بايت",
    bulk_upload: "تحميل مجمع",
    choose_file: "اختر ملف",
    status: "الحالة",
    select_customer: "حدد الزبون",
    delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا العميل؟",
    form: {
      hint:'بحد أقصى 100 حرفًا فقط',
      customer_sub_name: "الاسم الفرعي للزبون",
      status: "الحالة",
      project_types: "نوع المشروع",
      product_name: "اسم المنتج",
      project_name: "اسم المشروع",
      location_category_name: "اسم فئة الموقع",
      category_name: "اسم التصنيف",
      add_customer: "أضف الزبون",
      edit_customer: "تحرير الزبون",
      personal_information: "معلومات شخصية",
      name: "الاسم",
      description: "الوصف",
      email_id: "معرف البريد الإلكتروني الأساسي",
      group_email_id: "معرف البريد الإلكتروني الثانوي",
      contact_number: "رقم التواصل",
      customer_logo: "شعار العميل",
      is_active: "نشط",
      is_inactive: "غير نشط",
      address_line1: "العنوان 1",
      address_line2: "العنوان 2",
      country: "الدولة",
      select_country: "حدد الدولة",
      state: "ولاية",
      select_state: "اختر ولايه",
      city: "المدينة",
      select_city: "اختر مدينة",
      pincode: "الرمز السري",
      pincode_val: "الرمز_السري",
      category: "الفئة",
      select_category: "اختر الفئة",
      color_configration: "تكوين اللون",
      alert: "تنبيه",
      select: "اختيار",
      threshold: "الحد الأدنى",
      product_types: "أنواع المنتجات",
      normal: "طبيعي",
      user_configration: "تكوين المستخدم",
      username: "اسم المستخدم",
      password: "كلمة المرور",
      confirm_password: "تأكيد كلمة المرور",
      cancel: "إلغاء",
      loading: "جار التحميل..",
      select_pincode: "حدد الرمز السري",
      submit: "إرسال",
      customer_status: "حالة العميل",
      business_type: "نوع العمل",
      billing_type: "نوع الفاتورة",
      prepaid: "مسبقة الدفع",
      postpaid: "الدفع الآجل",
      utility_type: "نوع المنفعة",
      select_utility: "تحديد الخدمة",
      phone_number: "رقم الهاتف",
      mobile_number: "رقم الهاتف المحمول",
      plus_nine_one: "واحد و تسعون",
      new_customer: "عميل جديد",
      retrofit: "التحديثية",
      customer_name: "اسم الزبون",
      oem_fit: "    OEM صالح    ",
      retro_fit: "ريترو صالح",
      about_customer: "عن الزبون",
      select_mode: "حدد الوضع",
      current_mode: "الوضع الحالي",
      batch_mode_data: "الوضع 1 (بيانات الوضع الدفعي)",
      instantaneous_data: "الوضع 2 (بيانات فورية)",
      slAppCredentials: "أوراق اعتماد تطبيق الضوء الذكي",
      oldLampWattageLabel:"المصباح القديم القوة الكهربائية",
      ledWattageLabel:"مصباح جديد  القوة الكهربائية",
      ledModelNumberLabel:"رقم موديل الصمام",
      minPowerConsumptionLable:"الحد الأدنى من استهلاك الطاقة",
      maxPowerConsumptionLable:"أقصى استهلاك للطاقة",
      lampBrand:"اسم العلامة التجارية للمصباح",
      lamp:"خروف",
      modelNumbers: "أرقام الطرازات"
    }
  }
};
